import { callPost, callPostWithFormData } from "apis"
import { AxiosResponse } from "axios"

export class ContactUsAPI {
  async sendFeedback(userId:number, content: string, attachment?: File): Promise<AxiosResponse<any> | null> {
    const deviceDetails = {
      browserVersion: "N/A",
      platform: "N/A",
      appVersion: "N/A",
      userAgent: navigator.userAgent,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    }
    if (attachment) {
      const formData = new FormData()
      formData.append("content", content + "\n")
      formData.append("attachment", attachment, attachment.name)

      formData.append("deviceDetails[browserVersion]", deviceDetails.browserVersion)
      formData.append("deviceDetails[platform]", deviceDetails.platform)
      formData.append("deviceDetails[appVersion]", deviceDetails.appVersion)
      formData.append("deviceDetails[userAgent]", deviceDetails.userAgent)
      formData.append("deviceDetails[windowHeight]", deviceDetails.windowHeight.toString())
      formData.append("deviceDetails[windowWidth]", deviceDetails.windowWidth.toString())

      return await callPostWithFormData(`/users/${userId}/send`, formData, true)
    } else {
      return await callPost(`/users/${userId}/send`, {
        content: content + "\n",
        deviceDetails,
      })
    }
  }
}
